import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const inputGroupAddonVariants = cva(
  [
    'text-gray-600 h-auto gap-2 py-2 font-medium group-has-[[data-slot=input-group-control]:disabled]/input-group:opacity-50 flex cursor-text items-center justify-center select-none',
    "group-data-[size=small]/input-group:[&>svg:not([class*='size-'])]:!size-3.5",
    "group-data-[size=medium]/input-group:[&>svg:not([class*='size-'])]:!size-4",
    "group-data-[size=large]/input-group:[&>svg:not([class*='size-'])]:!size-5",
  ].join(' '),
  {
    variants: {
      align: {
        'inline-start': 'order-first pl-3 has-[>button]:-ml-2 has-[>kbd]:ml-0.5',
        'inline-end': 'order-last pr-3 has-[>button]:-mr-2 has-[>kbd]:mr-0.5',
        'block-start':
          'order-first w-full justify-start px-3 pt-2 group-has-[>input]/input-group:pt-2.5 [.border-b]:pb-2.5',
        'block-end':
          'order-last w-full justify-start px-3 pb-1.5 group-has-[>input]/input-group:pb-2.5 [.border-t]:pt-2.5',
      },
    },
    defaultVariants: {
      align: 'inline-start',
    },
  },
);

const InputGroupAddon = ({
  className,
  align = 'inline-start',
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof inputGroupAddonVariants>) => {
  return (
    <div
      role="group"
      data-slot="input-group-addon"
      data-align={align}
      className={cn(inputGroupAddonVariants({ align }), className)}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest('button')) {
          return;
        }
        e.currentTarget.parentElement?.querySelector('input')?.focus();
      }}
      {...props}
    />
  );
};

export default InputGroupAddon;
